export const ProtocolExplorerModal = {
  RENAME_PROTOCOL: 'renameProtocol',
  CREATE_FOLDER: 'createFolder',
  REMOVE_PROTOCOL: 'removeProtocol',
  PLATE_SELECTION: 'plateSelection',
  SEND_COPY_PROTOCOL: 'sendCopyProtocol',
};

export const ProtocolMenuTypes = {
  DUPLICATE: 'duplicate',
  FAVORITE_PROTOCOL: 'favoriteProtocol',
  RENAME: 'rename',
  SEND_A_COPY_PROTOCOL: 'sendACopy',
  SHARE_PROTOCOL: 'shareProtocol',
  CUT: 'cut',
  COPY: 'copy',
  PASTE: 'paste',
  DOWNLOAD: 'download',
  TRASH: 'trash',
  CONVERT_TESSARA_PROTOCOL: 'convertTessaraProtocol',
  IMPORT: 'import',
  EXPORT: 'export',
  OPEN_PROTOCOL_LOCATION: 'openProtocolLocation',
};

export const BaseProtocolMenu = [
  ProtocolMenuTypes.DUPLICATE,
  ProtocolMenuTypes.FAVORITE_PROTOCOL,
  ProtocolMenuTypes.OPEN_PROTOCOL_LOCATION,
  ProtocolMenuTypes.RENAME,
  ProtocolMenuTypes.SEND_A_COPY_PROTOCOL,
  ProtocolMenuTypes.SHARE_PROTOCOL,
  ProtocolMenuTypes.CUT,
  ProtocolMenuTypes.COPY,
  ProtocolMenuTypes.PASTE,
  ProtocolMenuTypes.CONVERT_TESSARA_PROTOCOL,
  ProtocolMenuTypes.DOWNLOAD,
  ProtocolMenuTypes.TRASH,
];

export const ExplorerHeaderProtocolMenu = [
  ProtocolMenuTypes.DUPLICATE,
  ProtocolMenuTypes.FAVORITE_PROTOCOL,
  ProtocolMenuTypes.OPEN_PROTOCOL_LOCATION,
  ProtocolMenuTypes.RENAME,
  ProtocolMenuTypes.SEND_A_COPY_PROTOCOL,
  ProtocolMenuTypes.SHARE_PROTOCOL,
  ProtocolMenuTypes.CUT,
  ProtocolMenuTypes.COPY,
  ProtocolMenuTypes.PASTE,
  ProtocolMenuTypes.IMPORT,
  ProtocolMenuTypes.DOWNLOAD,
  ProtocolMenuTypes.TRASH,
];

export const TessaraSuperuserProtocolMenu = [...BaseProtocolMenu, ProtocolMenuTypes.CONVERT_TESSARA_PROTOCOL];

export const ProtocolExplorerAccordionGroup = {
  FAVORITE_PROTOCOLS: 'favoriteProtocols',
  FOLDERS: 'folders',
  PROTOCOLS: 'protocols',
};

export const ProtocolExplorerAccordionGroupOrder = [
  [ProtocolExplorerAccordionGroup.FAVORITE_PROTOCOLS],
  [ProtocolExplorerAccordionGroup.FOLDERS],
  [ProtocolExplorerAccordionGroup.PROTOCOLS],
];

export const ProtocolExplorerFilterType = {
  ALL_ITEMS: 'all',
  NAME: 'name',
  SAVED_IN_TRAY: 'savedInTray',
  TESSARA_PROTOCOLS: 'tessaraProtocols',
  TRAY_TYPE: 'trayType',
  SHARED_ITEMS: 'sharedItems',
};

export const ProtocolExplorerSortingAccessor = {
  NAME: 'name',
  DATE_MODIFIED: 'modifiedString',
  DATE_CREATED: 'createdString',
};
